const deleteCard = () => {};

export default deleteCard;
